export function hashParams(params) {
    if (typeof params != 'object') {
        throw new Error('function requires an object');
    }
    return JSON.stringify(params);
}
